import { render, staticRenderFns } from "./KeyValueItemList.vue?vue&type=template&id=ed66c2e8&"
import script from "./KeyValueItemList.vue?vue&type=script&lang=js&"
export * from "./KeyValueItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports